import { render, staticRenderFns } from "./applyExam.vue?vue&type=template&id=d06582d2&scoped=true"
import script from "./applyExam.vue?vue&type=script&lang=js"
export * from "./applyExam.vue?vue&type=script&lang=js"
import style0 from "./applyExam.vue?vue&type=style&index=0&id=d06582d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06582d2",
  null
  
)

export default component.exports